"use client";

import { c as _c } from "react/compiler-runtime";
import { Logo } from "@repo/ui/logo";
import { ImageWrapper } from "@/components/common/image/image.component";
import type { ImageFeatureCarouselCard } from "./image-feature-carousel.types";
interface CardLogoProps {
  card: ImageFeatureCarouselCard;
  isDark: boolean;
}

/**
 * Renders the active card's CMS-driven logo, falling back to the V&A
 * Waterfront wordmark when no logo is configured. Container is fixed at the
 * Figma "Card-Size-Subbrand Logos" slot (110×80). Tenant logos vary widely
 * in aspect ratio, so we let the asset fill the slot with `object-contain` —
 * this scales each logo to its largest fitting size while preserving its
 * natural ratio. The V&A wordmark fallback is sized to its 77.78px Figma
 * width to match the original spec.
 */
export function CardLogo(t0) {
  const $ = _c(3);
  const {
    card,
    isDark
  } = t0;
  const cmsLogo = isDark ? card.logo?.logoDark ?? card.logo?.logoLight : card.logo?.logoLight ?? card.logo?.logoDark;
  let t1;
  if ($[0] !== cmsLogo || $[1] !== isDark) {
    t1 = <div className="flex h-[80px] w-[110px] items-end justify-start">{cmsLogo ? <ImageWrapper visual={cmsLogo} className="h-full w-full" imgClassName="object-contain object-left-bottom" resizeMode="contain" /> : <Logo name="va-waterfront" isDark={isDark} decorative={true} className="w-[77.78px]" />}</div>;
    $[0] = cmsLogo;
    $[1] = isDark;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}